import { useState } from "react";
import { Link } from "react-router-dom";

// import { useMutation } from "@tanstack/react-query";
import style from '../../styles/grid.module.css'
import {GetPorcentajes} from '../../actions/Porcentaje'
import { Pencil, SquareX, CirclePlus } from "lucide-react";

const API_URL = process.env.REACT_APP_URL_DIR + "Porcentaje";

const Porcentaje = () => {
   const token = localStorage.getItem("token");
   // const url = process.env.REACT_APP_URL_DIR + "porcentaje";    
   const [nombre, setName] = useState("");
   const { data,refetch } = GetPorcentajes();
   // const [onChange, setOnChange] = useState(false);
   // const location = useLocation();
   // const { state } = location;

   const handleDelete = async (id) => {
   if (!window.confirm("¿Está seguro que desea eliminar este registro?")) {
      return;
   }
      await fetch(`${API_URL}/${id}`, {
         method: "DELETE",
         headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
         },
      });
      refetch();
   };


   // const { mutate: getNombre} = useMutation({
   //    mutationFn: (nombre) =>
   //       fetch(`${url}?nombre=${nombre}`,
   //          {
   //             method: "GET",
   //             // body: JSON.stringify(newPost),
   //             headers: {
   //                "Authorization": `Bearer ${token}`,
   //                "Content-Type": "application/json",
   //             },
   //          }).then((res) => res.json()),
   //          onSuccess: () => {
   //            //  setData(data)
   //          //window.location.href = "/clientes";
   //       },
   //       onError:()=>{
   //          alert('Error')
   //       }
   // });

   // function handleInputChange(e) {
   //    if (e.key === "Enter") {
   //       dispatch(UpdatePorcentaje(usr, nombre));
   //       setName("");
   //    }
   // }

   // function handleInputChange(e) {
   //    if (e.key === "Enter") {
   //       console.log("nombre: ", nombre);
   //       // getNombre(nombre);
   //       setName("");
   //    }
   // }

   // const { mutate } = useMutation({
   //    mutationFn: (id) =>
   //       fetch(url + "/" + id, {
   //          method: "DELETE",
   //          body: JSON.stringify(),
   //          headers: {
   //             Authorization: `Bearer ${token}`,
   //             "Content-Type": "application/json",
   //          },
   //       }).then((res) => res.json()),
   //    onSuccess: (res) => {
   //       if (res?.message){
   //          alert(`Aviso : ${res.message}`)
   //      }
   //       window.location.href = "/clientes";
   //    },
   //    onError: () => {
   //       alert("Error");
   //    },
   // });


   // const handleRemove = (id) => {
   //    let text =
   //       "Se va a eliminar el Cliente selecionado!\nSelecione Aceptar or Cancelar.";
   //    if (confirm(text) == true) {
   //       mutate(id);
   //    }
   // };
   console.log("porcentaje: ", data);

   return (
      <>
         <div className={style.tableCli}>
            <div className={style.header}>
               <div className={style.gridTitle}>
                  <h2>Porcentajes</h2>
               </div>
               {/* <div>
                  <label htmlFor="search-navbar">Buscar:&nbsp;</label>
                  <input
                     className={style.inputBuscar}
                     onKeyPress={(e) => handleInputChange(e)}
                     onChange={(e) => setName(e.target.value)}
                     type="text"
                     id="search-navbar"
                     placeholder="Buscar..."
                     value={nombre}
                  />
               </div> */}
               <div>
                  <Link
                     to={"/formPorcentaje"}
                     className="dLink"
                     title="Alta porcentaje"
                     state={{
                        id: 0,
                        companyId: 0,
                        cod_status: 1,
                        porcentaje: 0,
                        serv_id: 0,
                        usr_id: 0,
                        usr_serv: '',
                     }}
                  >
                     <CirclePlus style={{color: 'white'}}/>
                  </Link>
                  &nbsp;&nbsp;
               </div>
            </div>
            <div>
               <table className={style.gridTable}>
                  <thead>
                     <tr>
                        <th>Servicio</th>
                        <th>Comisiona</th>
                        <th>Usuario que genera</th>
                        <th className={style.style_tit_precio}>Porcentaje</th>
                        <th>Acciones</th>
                     </tr>
                  </thead>
                  <tbody>
                     {data &&
                        data.map((porc, i) => {
                           return (
                              <tr key={i}>
                                 <td className={style.style_td}>
                                    {porc.servicio.descripcion}
                                 </td>
                                 <td className={style.style_td}>
                                    {porc.usuario.nombrecompleto}
                                 </td>
                                 <td className={style.style_td}>
                                    {porc.profesional.nombrecompleto}
                                 </td>
                                 <td className={style.style_precio}>
                                    {porc.porcentaje} %
                                 </td>
                                 <td>
                                    <Link
                                       to={"/formPorcentaje"}
                                       className="dLink"
                                       state={{
                                          id: porc.id,
                                          usr_id: porc.usr_id,
                                          usr_serv: porc.usr_serv,
                                          companyId: porc.companyId,
                                          serv_id: porc.serv_id,
                                          name: porc.name,
                                          porcentaje: porc.porcentaje,
                                          cod_status: porc.cod_status,
                                       }}
                                    >
                                        <Pencil /> 
                                    </Link>
                                    &nbsp;&nbsp;
                                                                     <span
                                    title="Eliminar"
                                    className="lucideIconDel"
                                    onClick={() => handleDelete( porc.id)}
                                 >
                                    <SquareX />
                                 </span>           

                                 </td>
                              </tr>
                           );
                        })}
                  </tbody>
               </table>
            </div>
         </div>
      </>
   );
};

export default Porcentaje;
